import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S2-WB2
// (PRA-788). Now served by `api-core-node` at
// `POST /api/firms/google-workspace/auth-url`. The Firebase callable
// `generateGoogleAuthUrl` continues to exist in `cloudFunctions/` so that
// any deployed app version still holding the old route table can fall back
// to it; retirement of the callable export is deferred to S9-WB2.

export const generateGoogleAuthUrlRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/google-workspace/auth-url',
} as const satisfies BackendRouteDefinition;
